import { useState } from "react";
import useDialogHooks from "../../../../../Components/Dialog/dialog-hooks";
import { useGeneralHooks, useToastify } from "../../../../../Hooks/hooks";
import { IImagePresetTypes } from "../../../../../Interfaces/componentTypes";
import { IQrProps } from "./qr";

const useMenuQrHooks = (props: IQrProps) => {
    const { qrImage, companyTitle, company_id } = props;
    const { baseURL, t } = useGeneralHooks();
    const { open: isDialogOpen, onOpen, onClose: onCloseDialog } = useDialogHooks();
    const { showToastSuccess, showToastError } = useToastify();
    const [width, setWidth] = useState(300);
    const [height, setHeight] = useState(300);
    const [selectedSize, setSelectedSize] = useState<number>(2);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const fullImageUrl = `${baseURL}${qrImage}`;
    const link = `www.mrbyte.am/${companyTitle.replace(' ','')}/menu/${company_id}`;

    const copyAndShareTelegram = async () => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(link);
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = link;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
            }
            window.open(`https://t.me/share/url?url=${encodeURIComponent(link)}`, "_blank");
        } catch (error) {
            alert("Failed to copy:");
        }
    };

    const shareOnWhatsApp = () => {
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(link)}`, "_blank");
    };

    const shareOnFacebook = () => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`, "_blank");
    };


    const onOpenDialog = () => {
        onOpen()
    };

    function onSetImageSizes(data: IImagePresetTypes) {
        setSelectedSize(data.id);
        setHeight(data.height);
        setWidth(data.width);
    };

    const handleDownload = () => {
        setIsLoading(true);
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = fullImageUrl;

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');

            if (ctx) {
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob) => {
                    if (blob) {
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = 'qr-code.png';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                    }
                    showToastSuccess('Image was downloaded')
                    setIsLoading(false);
                    onCloseDialog()
                }, 'image/png');
            }
        };

        img.onerror = (error) => {
            showToastError('Failed to load image:')
            setIsLoading(false);
        };
    };

    const PRESET_SIZES: IImagePresetTypes[] = [
        { label: t('Img_Presets.Small'), sizes: '150x150', width: 150, height: 150, id: 1 },
        { label: t('Img_Presets.Normal'), sizes: '300x300', width: 300, height: 300, id: 2 },
        { label: t('Img_Presets.Large'), sizes: '600x600', width: 600, height: 600, id: 3 },
        { label: t('Img_Presets.Full'), sizes: '1080x1080', width: 1080, height: 1080, id: 4 },
    ];

    return {
        isLoading,
        isDialogOpen,
        fullImageUrl,
        selectedSize,
        PRESET_SIZES,
        onOpenDialog,
        onCloseDialog,
        handleDownload,
        shareOnFacebook,
        onSetImageSizes,
        shareOnWhatsApp,
        copyAndShareTelegram,
    }
};

export default useMenuQrHooks